var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,style:('height :' + _vm.height)},[_c('img',{staticClass:"logo0",attrs:{"src":require("@/assets/logo.png"),"height":_vm.height,"alt":"Pixipine"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }